var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bot-arm-wrapper"},[_c('div',{staticClass:"bot-arm-shadow",style:('background-image: url('+_vm.bot_arm_shadow+');')}),_vm._v(" "),_c('div',{staticClass:"bot-arm",style:('background-image: url('+_vm.bot_arm+');')})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fcc52468","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/sections/botArm.vue
// module id = 490
// module chunks = 1